import views from '@/views/';

export default [
  {
    component: views.systemSet.clinicManagement,
    label: '诊所管理',
    path: 'clinicManagement',
    name: 'clinicManagement',
  },
  {
    component: views.systemSet.newClinic,
    label: '新增诊所',
    path: 'newClinic',
    name: 'newClinic',
    menuHidden: true,
  },
  {
    component: views.systemSet.platformAudit,
    label: '平台审核',
    path: 'platformAudit',
    name: 'platformAudit',
  },
  {
    component: views.systemSet.drugAudit,
    label: '中央库管理',
    path: 'drugAudit',
    name: 'drugAudit',
  },
  {
    component: views.systemSet.userManagement,
    label: '用户管理',
    path: 'userManagement',
    name: 'userManagement',
  },
  {
    component: views.systemSet.newUser,
    label: '新增用户',
    path: 'newUser',
    name: 'newUser',
    menuHidden: true,
  },
  {
    component: views.systemSet.information,
    label: '资讯管理',
    path: 'information',
    name: 'information',
  },
  {
    component: views.systemSet.newInformation,
    label: '新增资讯',
    path: 'newInformation',
    name: 'newInformation',
    menuHidden: true,
  }, {
    component: views.systemSet.applyRegisterList,
    label: '申请注册管理',
    path: 'applyRegisterList',
    name: 'applyRegisterList',
  },
];
